import Aside from "../../components/Aside";
import Footer from "../../components/Footer";
import Header from "../../components/Header";
import { Link, useNavigate } from "react-router-dom";
import EmptyState from "../../components/EmptyState";
import HandleNoData from "../../components/HandleNoData";
import { useState, useEffect } from "react";
import { EmailTemplateService } from "../../services/emailTemplateService";
import moment from "moment";
import PreviewModal from "./PreviewModal";
import Alert from "../../components/Alert";

export default function EmailPage() {
  const navigate = useNavigate();

  const [rows, setRows] = useState([]);
  const [showPreviewModal, setShowPreviewModal] = useState(false);
  const [html, setHtml] = useState('');

  const getTemplates = async () => {
    const response = await EmailTemplateService.getAll();
    setRows(response);
  };

  const deleteTemplate = async (id: string) => {
    
    const isOK = await Alert.danger({
      title: "Eliminar plantilla",
      text: "Al eliminar la plantilla se perderán todos los datos asociados a ella.",
      cancelText: "Cancelar",
      confirmText: "Eliminar",
    });

    if (isOK) {
      await EmailTemplateService.delete(id);
      getTemplates();

      Alert.close();
    }
  };

  useEffect(() => {
    getTemplates();
  }, []);

  return (
    <>
      <Header>
        <div>
          <h4>Plantillas de correo</h4>
          <p>Administra y crea nuevas plantillas de correo</p>
        </div>

        <div className="ms-auto">
          <button
            type="button"
            className="btn btn-primary btn-sm"
            onClick={() => navigate(`/templates/email/builder`)}
          >
            Crear plantilla
          </button>
        </div>
      </Header>

      <Aside />

      <main role="main" className="main">
        <div className="content container px-5">
          <HandleNoData condition={rows.length} emptyComponent={<EmptyState />}>
            <table className="card-table table">
              <thead>
                <tr>
                  <th scope="col">Nombre de plantilla</th>
                  <th scope="col">Fecha de creación</th>
                  <th scope="col">Fecha de última actualización</th>
                  <th scope="col"></th>
                </tr>
              </thead>
              <tbody>
                {rows.map((row) => (
                  <tr key={row._id}>
                    <td>
                      <p>{row.name}</p>
                      <p>
                        <small className="text-muted">ID: {row._id}</small>
                      </p>
                    </td>
                    <td>{moment(row.created_at).format("D MMMM YYYY HH:mm")}</td>
                    <td>
                      {moment(row.updated_at).format("D MMMM YYYY HH:mm")}
                    </td>
                    <td>
                      <button
                        type="button"
                        className="btn btn-outline-primary btn-outline-edit btn-icon m-l-8"
                        onClick={() => {
                          setShowPreviewModal(true)
                          setHtml(row.html)
                        } }
                      >
                        <i className="bi bi-eye-fill"></i>
                      </button>
                      <button
                        type="button"
                        className="btn btn-outline-primary btn-outline-edit btn-icon m-l-8"
                        onClick={() =>
                          navigate(`/templates/email/builder`, {
                            state: { template: row },
                          })
                        }
                      >
                        <i className="bi bi-pencil-fill"></i>
                      </button>
                      {/* <button
                        type="button"
                        className="btn btn-outline-danger btn-outline-danger btn-icon m-l-8"
                        onClick={() => deleteTemplate(row._id) }
                      >
                        <i className="bi bi-trash-fill"></i>
                      </button> */}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </HandleNoData>
        </div>
        <Footer />
      </main>

      <PreviewModal 
        open={showPreviewModal} 
        onClose={() => setShowPreviewModal(false) } 
        html={html}
      />
    </>
  );
}
